import Flickity from 'flickity';
import 'flickity/css/flickity.css';
import '../../css/vendor/flickity.scss';
import naja from 'naja';

// This is a code-split page entry, so the carousel's CSS ships with it: npm base stylesheet
// first, then the eHUB brand override (css/vendor/flickity.scss) so the override wins.

const optionsOf = (el) => JSON.parse(el.getAttribute('data-flickity') || '{}');

const initFlickity = (el) => {
  if (!Flickity.data(el)) {
    new Flickity(el, optionsOf(el));
  }
};

const reinitFlickity = (el) => {
  const existing = Flickity.data(el);

  if (existing) {
    existing.destroy();
  }

  new Flickity(el, optionsOf(el));
};

const initAll = () => {
  document.querySelectorAll('[data-flickity]').forEach(initFlickity);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

// Re-initialize carousels whose content was swapped by a Naja snippet update (e.g. the Publisher
// review gallery on category switch — replaces the former Nittro snippet-script destroy/init dance).
naja.snippetHandler.addEventListener('afterUpdate', (event) => {
  const { snippet } = event.detail;

  if (!snippet || !snippet.querySelectorAll) {
    return;
  }

  if (snippet.matches('[data-flickity]')) {
    reinitFlickity(snippet);
  }

  snippet.querySelectorAll('[data-flickity]').forEach(reinitFlickity);
});
